exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".articleModal[data-v-6b010f8a]{z-index:333 !important}", ""]);

// exports
